/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "CBOR_Error_BytesTooLong",
        type: "error",
    },
    {
        inputs: [],
        name: "CBOR_Error_InvalidKey",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "CBOR_Error_InvalidLength",
        type: "error",
    },
    {
        inputs: [],
        name: "CBOR_Error_InvalidMap",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        name: "CBOR_Error_InvalidUintPrefix",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        name: "CBOR_Error_InvalidUintSize",
        type: "error",
    },
    {
        inputs: [],
        name: "CBOR_Error_UintTooLong",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        name: "CoreCallDataPublicKeyError",
        type: "error",
    },
    {
        inputs: [],
        name: "SubcallError",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "encryptCallData",
        outputs: [
            {
                internalType: "bytes",
                name: "out_encrypted",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
            {
                internalType: "Sapphire.Curve25519PublicKey",
                name: "myPublic",
                type: "bytes32",
            },
            {
                internalType: "Sapphire.Curve25519SecretKey",
                name: "mySecret",
                type: "bytes32",
            },
            {
                internalType: "bytes15",
                name: "nonce",
                type: "bytes15",
            },
            {
                internalType: "uint256",
                name: "epoch",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "peerPublicKey",
                type: "bytes32",
            },
        ],
        name: "encryptCallData",
        outputs: [
            {
                internalType: "bytes",
                name: "out_encrypted",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class CalldataEncryption__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
CalldataEncryption__factory.bytecode = _bytecode;
CalldataEncryption__factory.abi = _abi;
//# sourceMappingURL=CalldataEncryption__factory.js.map